import * as React from 'react';
import { useEffect } from 'react';
import styles from '../../Loading.module.scss';
//redux
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { bindActionCreators, Dispatch } from 'redux';
//redux states
import { RootState } from '../../store';
import { loginActions } from '../../store/login/actions';
import { LoginState } from '../../store/login/reducer';
//utils
import { BounceLoader } from 'react-spinners';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';

export interface AutoLoginURLMatch {
  isExact: boolean;
  path: string;
  url: string;
}

export interface AutoLoginProps extends RouteComponentProps {
  actions: {
    newLoginRequest: (a: string, b: string) => void;
  };
  loginState: LoginState;
}
export const AutoLogin: React.FC<AutoLoginProps> = ({
  loginState,
  actions,
}) => {
  const { t } = useTranslation();

  const search = window.location.href.split('/auth/sso?')[1] || '';
  const params = new URLSearchParams(search);

  const token = params.get('token');
  let redirect = params.get('redirect');
  if (redirect) {
    if (!redirect.includes('http')) {
      redirect = 'https://' + redirect;
    }
    const url = new URL(redirect);
    const INTERNAL_URLS = [
      'webapp.tipsterchat.com',
      'www.webapp.tipsterchat.com',
      'webappbeta.tipsterchat.com',
      'www.webappbeta.tipsterchat.com',
      'tipsterchat.com',
      'www.tipsterchat.com',
      'beta.tipsterchat.com',
      'www.beta.tipsterchat.com',
      'localhost:3000',
    ];
    if (INTERNAL_URLS.indexOf(url.hostname) > -1) {
      redirect = url.pathname + url.search;
    } else {
      window.location.href = redirect;
    }
  }

  useEffect(() => {
    const isLoginLoading = !loginState.requested || loginState.isLoading;

    if (!token || !redirect) {
      window.location.href = '/login';
      return;
    }

    const requestAutoLogin =
      !isLoginLoading &&
      !!token &&
      !loginState.autoLoginRequested &&
      !loginState.autoLoginIsLoading;

    if (requestAutoLogin && redirect) {
      actions.newLoginRequest(token, redirect);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginState, token, redirect, actions]);

  return (
    <div className={styles.loadingWrapper}>
      <div className={styles.loading}>
        <BounceLoader color={'#6633ff'} size={25} />
        <label>{tr(t, 'loading')} ...</label>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      newLoginRequest: loginActions.autoLoginRequestAction,
    },
    dispatch,
  ),
});

export const AutoLoginConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AutoLogin),
);
